import Vue from 'vue';
import Router from 'vue-router';
import Login from 'views/Login';
import Dashboard from 'views/dashboard/Dashboard';
import Page from 'views/Page';
import TempPage from 'views/TempPage';
import Settings from 'views/preferences/Settings';
import Context from 'views/preferences/Context';
import GroupAdmin from 'views/preferences/GroupAdmin';
import store from 'store';
import { APPEARANCE_RESET_ALERT, APPEARANCE_SET_PREFERENCES_VIEW } from 'store/mutationTypes';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: { permission: 0 }
        },
        {
            path: '/',
            name: 'Dashboard',
            component: Dashboard,
            meta: { permission: 1 }
        },
        {
            path: '/module/:moduleId/page/:pagePath',
            name: 'Page',
            component: Page,
            meta: { permission: 1 }
        },
        {
            path: '/tempmodule/:moduleId/temppage/:pagePath',
            name: 'TempPage',
            component: TempPage,
            meta: { permission: 1 }
        },
        {
            path: '/preferences/settings',
            name: 'Settings',
            component: Settings,
            meta: { permission: 2 }
        },
        {
            path: '/preferences/context',
            name: 'Context',
            component: Context,
            meta: { permission: 2 }
        },
        {
            path: '/preferences/groupAdmin',
            name: 'GroupAdmin',
            component: GroupAdmin,
            meta: { permission: 2 }
        },
        {
            path: '*',
            redirect: '/',
            meta: { permission: 0 }
        }
    ],
});

// For each route redirect, check if the `to` route requires authentication.
// If the user is not logged in and the route requires authentication then redirect
// to login screen.
router.beforeEach((to, from, next) => {
    // NOTE: We have to make sure that vue and vuex has finished initialising
    // so that the appropriate session data is made available.
    // e.g. when user refreshes page the session token needs to be loaded into the store
    // so we have to wait for that to occur before we process the beforeEach event.
    Vue.nextTick(() => {
        const isAuthenticated = store.getters['session/isAuthenticated'];

        store.commit(APPEARANCE_RESET_ALERT);
        // store.commit(APPEARANCE_SET_DEFAULT_CURSOR);

        // Change the side nav view dependent on if preferences are need to be shown.
        if (to.name === 'Settings' || to.name === 'Context' || to.name === 'GroupAdmin') {
            store.commit(APPEARANCE_SET_PREFERENCES_VIEW, true);
        } else {
            store.commit(APPEARANCE_SET_PREFERENCES_VIEW, false);
        }

        if (!isAuthenticated()) {
            if (to.name === 'Login') {
                next();
            } else {
                localStorage.setItem('id_returnroute', window.location.pathname);
                next('/login');
            }
        } else {
            //            next();

            // Check if role is allowed to view this screen
            const permission = to.meta.permission ? to.meta.permission : 4;
            if (permission <= 0 ||
              store.getters['session/isAllowedTo'](permission)) {
                next();
            } else {
                next('/');
            }
        }
    });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js